import { createSelector } from 'reselect';

import { PatternOptions } from 'Types/Designs';

import colorwayOptionsSelector from './Colorways';
import {
  installOptionsGroupSelector,
  installOptionsSelector
} from './Installs';
import roomOptionsSelector, { roomCategoryOptionsSelector, roomBrandMapSelector } from './Rooms';
import textureOptionsSelector from './Textures';
import { brandNameMapSelector } from 'Store/Site/Selectors';

const patternOptionsSelector = createSelector(
  colorwayOptionsSelector,
  installOptionsSelector,
  installOptionsGroupSelector,
  roomOptionsSelector,
  roomCategoryOptionsSelector,
  roomBrandMapSelector,
  brandNameMapSelector,
  textureOptionsSelector,
  (colorways, installs, installsBySize, rooms, roomCategories, roomBrandMap, brandNameMap, textures): PatternOptions => {
    return {
      colorways,
      installs,
      installsBySize,
      rooms,
      roomCategories,
      roomBrandMap,
      brandNameMap,
      textures
    };
  }
);

export default patternOptionsSelector;
